// const stringManipulator = (arr, splitter, operation) => {
//   array.forEach(currentItem => {});
//   arr.map((u, i) => {});
// };
import debounce from "lodash.debounce";
import queryString from "query-string";
export const returnQueryString = obj => {
  let str = [];
  for (let p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};
// export const customDebounce = function (a, b, c) {
//   var d, e;
//   return function () {
//     function h() {
//       (d = null), c || (e = a.apply(f, g));
//     }
//     var f = this,
//       g = arguments;
//     return (
//       clearTimeout(d), (d = setTimeout(h, b)), c && !d && (e = a.apply(f, g)), e
//     );
//   };
// };

export const debounceEventHandler = (...args) => {
  const debounced = debounce(...args);
  return function(e) {
    e.persist();
    return debounced(e);
  };
};
export const formatJsonApiData = response => {
  // console.log("response", response);
  if (response.hasOwnProperty("data")) {
    response = response.data;
  }
  let finalObj = {
    ...response.attributes
  };
  // console.log("finalObj1", finalObj);

  if (response.hasOwnProperty("relationships")) {
    let relationshipsObj = {};
    for (const key in response.relationships) {
      if (response.relationships.hasOwnProperty(key)) {
        const element = response.relationships[key];
        if (element.data) {
          let tempObj = formatJsonApiData(element.data);
          console.log("tempObj", tempObj);
          // debugger;
          const { type, ...finalElemData } = element.data;
          relationshipsObj[key] = { ...finalElemData };
        }
      }
    }

    finalObj = {
      ...finalObj,
      ...relationshipsObj
    };
  }

  // console.log("finalObj", finalObj);
  return finalObj;
};
export const setQueryParams = options => {
  let { url, history, location, newParams, removeParams } = options;
  const queryParams = {
    ...queryString.parse(location.search),
    ...newParams
  };
  if (removeParams) {
    removeParams.forEach(element => {
      if (queryParams.hasOwnProperty(element)) {
        delete queryParams[element];
      }
    });
  }
  // let { queryParamsWithRemovedParams, ...removeParams } = queryParams;

  // let finalQueryParams = queryString.stringify(queryParamsWithRemovedParams);
  let finalQueryParams = queryString.stringify(queryParams);
  console.log("url", url);
  history.push(`${url}?${finalQueryParams}`);
  // history.push({ pathname: url, search: `?${finalQueryParams}` });
  console.log("finalQueryParams", finalQueryParams);
};
export const returnFinalValue = (event, controlName) => {
  let finalValue;
  if (controlName === "object") {
    finalValue = event;
  } else if (typeof event == "string") {
    finalValue = event;
  } else if (Array.isArray(event)) {
    finalValue = event;
  } else {
    if (event.hasOwnProperty("target")) {
      finalValue = event.target.value;
    } else {
      finalValue = event;
    }
  }
  return finalValue;
};
export const getQueryParams = options => {
  let { location } = options;
  let finalQueryParams = queryString.parse(location.search);
  return finalQueryParams;
};

export const displayRole = role => {
  if(role === "superadmin"){
    return "Superadmin";
  }
  else if(role === "hospital_admin"){
    return "Hospital Admin";
  }
  else if(role === "data_entry"){
    return "Data Entry Operator";
  }
}

export const buildOptionsArr = options => {
  let optionsArr = []
  options.map((value, index) => {
    optionsArr.push({label: value, value: value})
  })
  // let optionsArr = [
  //   {
  //     label: "Yes",
  //     value: "Yes",
  //   },
  //   {
  //     label: "No",
  //     value: "No",
  //   },
  // ]
  return optionsArr;
}

export const buildSchemaObject = attrs => {
  // attrs = {key: "age_options", title: "Age in years", inputType: "string", radioOptions: "['Yes', 'No'], widget: 'InputNumberWidget'"}
  let obj = {
    type: "object",
    properties: {}
  }
  obj.properties[attrs.key] = {
    type: "string",
    title: attrs.title,
    setInitialValue: true,
    span: attrs.span,
    className: "conditional-child-input",
    widget: attrs.widget
  }
  if(attrs.inputType === "radio"){
    obj.properties.widgetConfig.options = buildOptionsArr(attrs.radioOptions)
  }
  return obj;
}

export const setToLS = (key, value) => {
  localStorage.setItem(key, value);
}

export const getFromLS = (key) => {
  return localStorage.getItem(key);
}
export const deleteFromLS = (key) => {
  return localStorage.removeItem(key);
}